import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import { useRoot } from './hooks/useRoot';
import { Hero } from './components/hero';
import { Boxes } from './components/boxes';
import { Assessment } from './components/assessment';
import { NextPart } from './components/next-part';
import { MediaLinks } from './components/media-links';
import { ClassVideo } from './components/class-video';
import Divider from '@/components/Divider';
import { ErrorScreen } from '../../Error';
import { Suspense } from 'react';
import { LoadingContainer } from '../shared/components/loading-container';
import { useChapterStore } from '../shared/store/useChapterStore';
import { ChapterNotes } from './components/notes';
import { ConsoleCJ } from '../../Error/Console';
import { MarkAsCompleted } from './components/mark-as-completed';
import PageHeader from '@/components/PageHeader';
import { ReflectionVideos } from './components/reflection-videos';
import { DownloadLinks } from './components/download-links';

const ChapterComponent = () => {
  const { chapter, showAssessment, showReflectionVideoSection, errors } = useRoot();
  const nextChapter = useChapterStore((state) => state.nextChapter);

  if (errors.length > 0) {
    ConsoleCJ.customError('ChapterScreen', {
      ...errors,
    });
    return <ErrorScreen />;
  }

  if (!chapter) {
    return <LoadingContainer title="Loading chapter..." />;
  }

  const Wrapper = ({ children }: { children: React.ReactNode }) => {
    return (
      <Container className="!mt-sh-60">
        <SubContainer className="lg:col-start-3 lg:col-end-11">
          <div className="mt-5 pb-10">{children}</div>
        </SubContainer>
      </Container>
    );
  };

  return (
    <Wrapper>
      <>
        <PageHeader title={'Chapter'} type="none" />
        <ClassVideo />
        <Hero />
        {showAssessment && <Assessment />}
        <Divider />
        <div className="flex flex-col gap-4">
          <Boxes />
          <MediaLinks />
          <DownloadLinks />
        </div>
        <Divider />
        {showReflectionVideoSection && <ReflectionVideos />}
        <ChapterNotes />
        {nextChapter && <Divider />}
        {nextChapter && <NextPart />}
        <MarkAsCompleted />
      </>
    </Wrapper>
  );
};

export const ChapterScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading chapter..." />}>
      <ChapterComponent />
    </Suspense>
  );
};
